import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { ReportProblemOutlined as AlertIcon } from '@mui/icons-material'
import { Box, Chip, Tooltip } from '@mui/material'

import { CommandConfigRowData } from '../CommandConfigTable'
import { TOOLTIP_SLOT_PROPS } from '../consts'

type ParameterCellProps = {
  row: CommandConfigRowData
}

export const ParameterCell = memo(({ row }: ParameterCellProps) => {
  const { t } = useTranslation()

  const description = row.description?.trim() ?? ''
  const hasDescription = description.length > 0

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, ml: 0.5 }}>
      <Tooltip
        arrow
        disableHoverListener={!hasDescription}
        placement='bottom'
        slotProps={TOOLTIP_SLOT_PROPS}
        title={description}
      >
        <Chip
          label={row.name}
          size='small'
          sx={{
            maxWidth: '100%',
            minWidth: 0,
            '& .MuiChip-label': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
        />
      </Tooltip>

      {row.isRequired ? (
        <Tooltip
          arrow
          placement='bottom'
          slotProps={TOOLTIP_SLOT_PROPS}
          title={t('form.fieldObjectRequired')}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <AlertIcon
              sx={{
                color: theme => theme.palette.color.warning,
                fontSize: '1.3rem',
              }}
            />
          </Box>
        </Tooltip>
      ) : null}
    </Box>
  )
})

ParameterCell.displayName = 'ParameterCell'
